import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/kumho/news-page-content/newsroom-banner.webp'


const _withScopeId = n => (_pushScopeId("data-v-3c8022b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"news_banner p-0\" data-v-3c8022b4><div class=\"banner_slider_wrapper\" data-v-3c8022b4><div class=\"box\" data-v-3c8022b4><div class=\"container wrapper\" data-v-3c8022b4><div class=\"text opacity-1\" data-v-3c8022b4><h1 class=\"heading_title title_2 white text-uppercase fst-italic\" data-v-3c8022b4> NEWSROOM </h1></div></div><img src=\"" + _imports_0 + "\" class=\"d-block w-100\" alt=\"Kumho Banner Image\" data-v-3c8022b4></div></div></section>", 1)
const _hoisted_2 = { class: "newspage" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-md-5 col-lg-4 col-xxl-3 d-flex align-items-center justify-content-end" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "img" }
const _hoisted_8 = { href: "#" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "btn_group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12 d-flex align-items-center justify-content-center mt-md-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "btn_group justify-content-center" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "static/pdf/Kumho-MT51-Tyre-Guide.pdf",
      target: "_blank",
      class: "btn red_btn"
    }, " Kumho MT51 Tyre Guide "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "static/pdf/Kumho-Solus-Info.pdf",
      download: "",
      class: "btn red_btn"
    }, " Kumho Solus Info Sheet ")
  ])
], -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roomList, (row, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "wrap",
                onClick: $event => (_ctx.roomDetails(row))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("a", _hoisted_8, [
                    _createElementVNode("img", {
                      src: _ctx.getImgUrl(row.image),
                      alt: row.title,
                      class: "img-fluid"
                    }, null, 8, _hoisted_9)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", {
                    href: "#",
                    class: _normalizeClass(["btn", index % 2 == 0 ?'red_btn':'black_btn'])
                  }, [
                    _createElementVNode("span", null, _toDisplayString(row.title), 1)
                  ], 2)
                ])
              ], 8, _hoisted_6)
            ]))
          }), 256)),
          _hoisted_11
        ])
      ])
    ])
  ], 64))
}